import { Modal } from 'baseui/modal';
import React, { useState } from 'react';
import { useEvents } from '../../../Components/Events/EventsProvider';
import { FinalButton } from '../../../Components/FinalButton';
import { Modal as ModalStyle, Text } from '../../../globalStyles';
import { useDeleteOrganizationResourceMutation } from '../../../graphQL';

type ConfirmDeleteModalProps = {
  onClose: () => void;
  onDelete: () => void;
  refetch: () => Promise<unknown>;
  resourceId: number;
  organizationId: number;
};

export const ConfirmDeleteModal = ({
  onClose,
  resourceId,
  refetch,
  organizationId,
  onDelete,
}: ConfirmDeleteModalProps) => {
  const { track } = useEvents();
  const [deleteResource] = useDeleteOrganizationResourceMutation({
    onCompleted: _ => track('campus-resource.deleted', { resourceId, organizationId }),
  });
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await deleteResource({ variables: { resourceId } });
      await refetch();
      onDelete();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal isOpen unstable_ModalBackdropScroll onClose={onClose}>
      <ModalStyle.body>
        <Text.h2 className="mb3">Delete this resource?</Text.h2>
        <Text.body className="mb3">
          This resource will be permanently removed and will no longer be visible to students.
        </Text.body>
        <FinalButton
          kind="minimal_danger"
          className="w-100"
          onClick={handleDelete}
          loading={deleting}
        >
          Delete
        </FinalButton>
        <ModalStyle.closeLink onClick={onClose}>Cancel</ModalStyle.closeLink>
      </ModalStyle.body>
    </Modal>
  );
};
